import Typography from '@/common/components/base/typography/Typography';
import { Flex } from 'styled-system/jsx';
import EmptyInboxIcon from '../../assets/icons/walletEmptyInbox.svg?react';

export default function WalletEmptyState({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <Flex flexDirection={'column'} alignItems={'center'} gap={16}>
      <EmptyInboxIcon />
      <Flex flexDirection={'column'} alignItems={'center'}>
        <Typography color={'black'}>{title}</Typography>
        {!!description && (
          <Typography fontSize={12} color={'black-2'} textAlign={'center'}>
            {description}
          </Typography>
        )}
      </Flex>
    </Flex>
  );
}
